<app-window [title]="title" [model]="this">
    <form role="form" id="detailForm">
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group form-group-sm">
                    <label>Stato</label>
                    <select name="status" class="form-control form-control-sm" name="status" [(ngModel)]="record.status">
                        <option value="0">Non pubblicato</option>
                        <option value="1">Pubblicato</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group form-group-sm">
                    <label>Tabella</label>
                    <app-selecttables [name]="'table'" [value]="record.table" [show_all]="false" (onchange)="record.table=$event;"></app-selecttables>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group form-group-sm">
                    <label>Ordinamento</label>
                    <input type="number" min="0" step="1" class="form-control form-control-sm" name="ordering" [(ngModel)]="record.ordering" />
                </div>
            </div>
        </div>

        <app-field-setting [f]="record" [fields]="customfields"></app-field-setting>


    </form>

    <app-toolbarmodel [model]="this" [showTodo]="true"  [showSaveAndClose]="true"></app-toolbarmodel>

</app-window>